import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';
import {emailValidator} from '../../../services/app-validators';
import {WishList} from '../../../classes/app.models';

@Component({
    selector: 'app-share-dialog',
    templateUrl: './share-dialog.component.html',
    styleUrls: ['./share-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ShareDialogComponent implements OnInit {
    shareForm: FormGroup;
    clicked: boolean;
    @Input() wishlist: WishList;

    constructor(private formBuilder: FormBuilder, private router: Router, private toastrService: ToastrService,
                public apiService: ApiService) {
    }

    ngOnInit() {
        this.shareForm = this.formBuilder.group({
            'email': ['', Validators.compose([Validators.required])]
        });
        this.clicked = false;
    }

    public onSubmit(values: Object): void {
     //  console.log(this.wishlist);
        this.clicked = true;
        if (this.shareForm.valid) {
            this.apiService.shareLightbox(values['email'], this.wishlist.id, 1).subscribe(data => {
                if (data.statusCode == 200) {

                    this.toastrService.success('Your wishlist on indiapicture.in has been successfully shared');
                    this.clicked = false;
                } else {
                    this.toastrService.error('There is some issue Share again');
                    this.clicked = false;
                }
            });
        }else{
            this.clicked = false;
        }
    }

    closeModal() {
        let modal = document.querySelector('.login-modal') as HTMLElement;
        if (modal) {
            modal.click();
        }
    }
}
